// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  -webkit-backface-visibility: hidden !important;
}

body {
  margin: 0;
  padding: 0;
  background: #F1F3F6;
  font-size: 14px;
  height: 24px;
  font-weight: 400;
}

a {
  text-decoration: none;
}

.loading-screen {
  width: 100vw;
  height: 100vh;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}

.ant-btn {
  padding: 6px 12px 6px 12px;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
  height: auto !important;
  border-radius: 2px;
}
.ant-btn span + .anticon {
  margin-right: 0;
  margin-left: 10px;
}

.ant-notification-notice-message {
  margin-bottom: 0 !important;
}

.text-capitalize {
  text-transform: capitalize;
}

.ant-layout-header {
  padding: 0;
  background-color: #23395d;
  display: flex;
  justify-content: space-between;
  width: 100%;
  z-index: 999;
}
.ant-layout-header .logo img {
  width: 200px;
  height: 60px;
}
.ant-layout-header .logo span {
  margin-left: 10px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  padding: 4px 7px;
  background-color: #fff;
  color: #1E88E5;
  border-radius: 11px;
}
.ant-layout-header .account-info {
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}
.ant-layout-header .account-info .avatar {
  width: 32px;
  margin-left: 10px;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}
.ant-layout-header .account-info .avatar img {
  width: 100%;
  border-radius: 50%;
}
.ant-layout-header .account-info .info {
  margin: auto 0;
  padding: 10px;
  line-height: 16px;
  font-size: 12px;
  color: #212121;
}
.ant-layout-header .account-info .info .fullname {
  font-weight: 600;
}
.ant-layout-header .account-info .info .info-dropdown button {
  width: 100%;
}
.ant-layout-header .account-info .ant-badge {
  margin: auto 10px;
}
.ant-layout-header .account-info .ant-badge .anticon {
  width: 40px;
}
.ant-layout-header .account-info .ant-badge .anticon svg {
  height: 24px;
}

.header-info-dropdown button {
  width: 100%;
  text-align: left;
}

.site-layout .Content {
  margin: 20px;
}
.site-layout .Content.Small {
  max-width: 760px;
  margin: 20px auto;
}

.ant-layout-header.site-header {
  background-color: #fff;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-justify-content: space-between;
  -o-justify-content: space-between;
  justify-content: space-between;
  z-index: 1;
}

.form-container .ant-form-item {
  margin-bottom: 16px;
}
.form-container .ant-form-item .ant-form-item-label {
  min-width: 156px;
  text-align: left;
}
.form-container .form-header .title {
  text-transform: uppercase;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  position: relative;
  color: #005670;
}
.form-container .form-header .title:before {
  content: "";
  width: 4px;
  height: 100%;
  background-color: #005670;
  position: absolute;
  top: 0;
  left: -16px;
}
.form-container .form-content {
  margin-top: 24px;
}
.form-container .form-content .ant-form-item-row .ant-form-item-control .ant-form-item-control-input .ant-form-item-control-input-content {
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}
.form-container .form-content .add-fields .ant-btn-dashed.ant-btn-block {
  width: auto;
  margin-top: 0;
}
.form-container .form-content .btn-remove-section {
  margin-bottom: 16px;
}
.form-container .form-content .btn-remove-section .ant-btn {
  padding: 4px 40px;
}
.form-container .form-content .ant-btn-dashed.ant-btn-block {
  margin-bottom: 16px;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}
.form-container .form-content .ant-btn-dashed.ant-btn-block.btn-remove {
  border-color: #F44336;
  color: #F44336;
}
.form-container .form-footer {
  margin-top: 24px;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-justify-content: flex-end;
  -o-justify-content: flex-end;
  justify-content: flex-end;
}
.form-container .form-footer button, .form-container .form-footer a {
  margin-left: 24px;
}
.form-container .form-footer button:first-child, .form-container .form-footer a:first-child {
  margin-left: 0;
}
.form-container .form-footer a > button:first-child {
  margin-right: 0;
}
.form-container .ant-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.form-container .ant-row .ant-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.form-container .fields-inline {
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-justify-content: space-between;
  -o-justify-content: space-between;
  justify-content: space-between;
}
.form-container .fields-inline .ant-form-item {
  width: 50%;
}
.form-container .fields-inline .ant-form-item:last-child {
  margin-left: 24px;
}
.form-container .fields-inline .ant-picker {
  width: 100%;
}
@media (max-width: 767px) {
  .form-container .ant-row {
    flex-flow: column;
  }
}

.ant-form-item-explain {
  height: auto;
  min-height: 0 !important;
}
.ant-form-item-explain .ant-form-item-explain-error {
  font-size: 10px;
  min-height: 12px;
  position: absolute;
  left: 0;
}

.ant-form-item-with-help.password-input .ant-form-item-explain div, .ant-form-item-with-help.password-input .ant-form-item-explain .ant-form-item-explain-error, .ant-form-item-with-help.password-input .ant-form-item-explain .ant-form-item-explain-success {
  font-size: 10px;
  min-height: 12px;
  position: absolute;
  top: 32px;
  left: 0;
}

.page-container {
  padding: 24px;
}
.page-container .page-header {
  margin-top: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-justify-content: space-between;
  -o-justify-content: space-between;
  justify-content: space-between;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}
.page-container .page-header .ant-breadcrumb span {
  text-transform: uppercase;
}
.page-container .page-header-actions {
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}
.page-container .page-header-actions button:not(:last-child), .page-container .page-header-actions a:not(:last-child) {
  margin-right: 12px;
}
.page-container .page-content {
  padding: 16px;
  margin: 24px auto;
  -ms-box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08);
  border-radius: 2px;
}
.page-container .page-content.list {
  width: 100%;
}
.page-container .page-content .page-content-header {
  margin-bottom: 24px;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-justify-content: space-between;
  -o-justify-content: space-between;
  justify-content: space-between;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}
.page-container .page-content .page-content-header h2.title-page {
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  position: relative;
  color: #23395d !important;
}
.page-container .page-content .page-content-header h2.title-page:before {
  content: "";
  width: 4px;
  height: 100%;
  background-color: #23395d !important;
  position: absolute;
  top: 0;
  left: -16px;
}
.page-container .page-content .page-content-header .page-content-header-actions {
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}
.page-container .page-content .page-content-header .page-content-header-actions button {
  margin-right: 16px;
}
.page-container .page-content .page-content-header .page-content-header-actions button:first-child {
  margin-left: 0;
}
.page-container .page-content .details-container .item {
  padding-top: 7.5px;
  padding-bottom: 7.5px;
  border-bottom: 1px solid #e0e0e0;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}
.page-container .page-content .details-container .item:last-child {
  border-bottom: none;
}
.page-container .page-content .details-container .item label {
  min-width: 152px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  white-space: pre-line;
  max-width: 152px;
  margin-right: 24px;
}
.page-container .page-content .details-container .item span.value {
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
}
.page-container .page-content .details-container .item span.value.status {
  display: block;
  width: 120px;
  padding-top: 4px;
  padding-bottom: 4px;
  font-weight: 600;
  font-size: 12px;
  font-style: normal;
  line-height: 16px;
  text-align: center;
  text-transform: capitalize;
  border-radius: 2px;
}
.page-container .page-content .details-container .item span.value.status.rejected, .page-container .page-content .details-container .item span.value.status.cancelled, .page-container .page-content .details-container .item span.value.status.disabled {
  color: #f44336;
  background-color: rgba(244, 67, 54, 0.12);
}
.page-container .page-content .details-container .item span.value.status.approved, .page-container .page-content .details-container .item span.value.status.completed, .page-container .page-content .details-container .item span.value.status.enabled, .page-container .page-content .details-container .item span.value.status.open, .page-container .page-content .details-container .item span.value.status.active {
  color: #00c853;
  background-color: rgba(0, 200, 83, 0.12);
}
.page-container .page-content .details-container .item span.value.status.pending, .page-container .page-content .details-container .item span.value.status.refunded, .page-container .page-content .details-container .item span.value.status.closed {
  color: #ad6800;
  background-color: #ffe58f;
}
.page-container .page-content .details-container .item span.value.status.created, .page-container .page-content .details-container .item span.value.status.inactive {
  color: #888888;
  background-color: rgba(136, 136, 136, 0.12);
}
.page-container .page-content .details-container .item span.value.status.acknowledged, .page-container .page-content .details-container .item span.value.status.upcoming {
  color: #1E88E5;
  background-color: rgba(30, 136, 229, 0.12);
}
.page-container .page-content .details-container .item span.value.status.attending {
  color: #FFC400;
  background-color: rgba(255, 196, 0, 0.12);
}
.page-container .page-content-footer {
  margin-top: 24px;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  -ms-justify-content: flex-end;
  -o-justify-content: flex-end;
  justify-content: flex-end;
}
.page-container .page-content-footer button, .page-container .page-content-footer a {
  margin-right: 12px;
}
.page-container .page-content-footer button:last-child, .page-container .page-content-footer a:last-child {
  margin-right: 0;
}
@media (max-width: 1199px) {
  .page-container .page-content {
    width: 100%;
  }
}
@media (max-width: 479px) {
  .page-container .page-content .details-container .item {
    -ms-align-items: flex-start;
    -o-align-items: flex-start;
    align-items: flex-start;
    flex-direction: column;
  }
  .page-container .page-content .details-container .item label {
    margin-bottom: 16px !important;
  }
}

.ant-modal-content .ant-modal-body {
  padding: 10px;
}
.ant-modal-content .ant-modal-body .form-header .title {
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  position: relative;
  color: #23395d !important;
}
.ant-modal-content .ant-modal-body .form-header .title:before {
  content: "";
  width: 4px;
  height: 100%;
  background-color: #23395d !important;
  position: absolute;
  top: 0;
  left: -16px;
}
.ant-modal-content .ant-modal-body .form-content .ant-form-item {
  flex-flow: column;
}
.ant-modal-content .ant-modal-body h2.title-page {
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  position: relative;
  color: #23395d !important;
  margin-bottom: 24px;
}
.ant-modal-content .ant-modal-body h2.title-page:before {
  content: "";
  width: 4px;
  height: 100%;
  background-color: #23395d !important;
  position: absolute;
  top: 0;
  left: -16px;
}

.ant-modal-confirm-confirm .ant-modal-content {
  width: 331px;
}
.ant-modal-confirm-confirm .ant-modal-content .ant-modal-body {
  padding: 0px;
}
.ant-modal-confirm-confirm .ant-modal-content .ant-modal-confirm-body {
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}
.ant-modal-confirm-confirm .ant-modal-content .ant-modal-confirm-body .ant-modal-confirm-content {
  margin-top: 0;
}
.ant-modal-confirm-confirm .ant-modal-content .ant-modal-confirm-body span.anticon.anticon-exclamation-circle {
  color: #F44336;
}
.ant-modal-confirm-confirm .ant-modal-content .ant-modal-confirm-btns {
  width: 100%;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
}
.ant-modal-confirm-confirm .ant-modal-content .ant-modal-confirm-btns button {
  min-width: 100px;
}
.ant-modal-confirm-confirm .ant-modal-content .ant-modal-confirm-btns button:first-child {
  background-color: #fff;
  color: #23395d !important;
  border: 1px solid #23395d !important;
}
.ant-modal-confirm-confirm .ant-modal-content .ant-modal-confirm-btns button.ant-btn-primary {
  margin-left: 16px;
  background-color: #23395d !important;
  color: #fff;
  border: 1px solid #23395d !important;
}

table thead.ant-table-thead th {
  padding: 10px 16px;
  border-top: 1px solid #F4F4F4;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  flex: none;
  background: #fff !important;
}
table thead.ant-table-thead th:first-child {
  border-right: 1px solid #F4F4F4;
}
table thead.ant-table-thead th:last-child {
  border-left: 1px solid #F4F4F4;
}
table thead.ant-table-thead th span.ant-table-filter-column-title {
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  flex: none;
  padding: 0;
}
table thead.ant-table-thead th .ant-table-filter-column {
  padding: 17px 16px;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}
table thead.ant-table-thead th .ant-table-filter-trigger-container {
  position: unset;
  margin-left: 5px;
}
table thead.ant-table-thead th .ant-table-filter-trigger-container:hover {
  background: #fff;
}
table thead.ant-table-thead th .ant-table-filter-trigger {
  text-align: center;
  border-radius: 2px;
}
table thead.ant-table-thead th .ant-table-filter-trigger .anticon {
  position: unset;
  color: #23395d !important;
  transform: none;
}
table td {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  background: #fff;
}
table tbody.ant-table-tbody tr td {
  padding: 12px 16px;
}
table tbody.ant-table-tbody tr td:first-child {
  border-right: 1px solid #F4F4F4;
}
table tbody.ant-table-tbody tr td:last-child {
  border-left: 1px solid #F4F4F4;
}
table tbody.ant-table-tbody tr td span.action {
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}
table tbody.ant-table-tbody tr td span.action > button, table tbody.ant-table-tbody tr td span.action > a {
  padding-left: 8px;
  padding-right: 8px;
}
table tbody.ant-table-tbody tr td span.action > button > button, table tbody.ant-table-tbody tr td span.action > a > button {
  padding: 6px 0;
}
table tbody.ant-table-tbody tr td span.action .ant-dropdown-button button {
  padding: 0 6px 0 6px;
  border: none;
  background-color: transparent;
  transform: rotate(90deg);
}
table tbody.ant-table-tbody tr td span.action .ant-dropdown-button button:first-child {
  display: none;
}
table tbody.ant-table-tbody tr td span.action .ant-dropdown-button button span.anticon.anticon-ellipsis {
  height: 16px;
}
table tbody.ant-table-tbody tr td span.table-status {
  text-transform: capitalize;
  padding-top: 4px;
  padding-bottom: 4px;
  width: 120px;
  display: block;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  text-align: center;
  border-radius: 2px;
}
table tbody.ant-table-tbody tr td span.table-status.active {
  color: #00C853;
  background-color: rgba(0, 200, 83, 0.12);
}
table tbody.ant-table-tbody tr td span.table-status.inactive {
  color: #888888;
  background-color: rgba(136, 136, 136, 0.12);
}
table tbody.ant-table-tbody tr td .foreign-currency-td {
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}
table tbody.ant-table-tbody tr td .foreign-currency-td > div {
  margin-right: 12px;
}
table tbody.ant-table-tbody tr td .foreign-currency-td > div > div {
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}
table tbody.ant-table-tbody tr td .sms-transaction-details .details-type {
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  text-transform: capitalize;
}
table tbody.ant-table-tbody tr td .sms-transaction-details .details-account-no {
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
}
table tbody.ant-table-tbody tr:last-child td {
  padding-bottom: 12px;
}
table tbody.ant-table-tbody .btn-download {
  position: relative;
  min-width: 100%;
  min-height: 32px;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}
table tbody.ant-table-tbody .btn-download > div {
  margin-left: 0px;
}
table tbody.ant-table-tbody .btn-download svg {
  width: 16px;
  height: 30px;
}

.table-action-menu .ant-dropdown-menu {
  border-radius: 4px;
}
.table-action-menu .ant-dropdown-menu .btn-danger {
  border: none;
  background-color: transparent;
  color: #F4F4F4 !important;
}

.ant-input, .ant-select-selector, .ant-picker {
  background-color: #fff;
  font-size: 14px !important;
  border: 1px solid #E0E0E0;
  border-radius: 2px !important;
  min-height: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum", "tnum", "tnum";
  position: relative;
  min-width: 0;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1.5715;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
}

input.ant-input::placeholder {
  color: #d9d9d9;
}

.ant-input:not[textarea], .ant-select-selector, .ant-picker {
  height: 32px !important;
}

.ant-input {
  min-height: 30px;
}
.ant-input:focus {
  border-color: #4096ff;
  box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);
  border-inline-end-width: 1px;
  outline: 0;
}

.filter-form-container .ant-input {
  min-height: 38px;
}
.filter-form-container .form-container {
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  flex-wrap: wrap;
}
.filter-form-container .form-container .form-content {
  margin-top: 0;
  flex-wrap: wrap;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}
.filter-form-container .form-container .form-content .ant-picker {
  width: auto;
  min-height: 38px;
}
.filter-form-container .form-container .form-content .ant-form-item, .filter-form-container .form-container .form-content .ant-select {
  min-width: 200px;
  margin-right: 16px !important;
}
.filter-form-container .form-container .form-content .ant-form-item:first-child, .filter-form-container .form-container .form-content .ant-select:first-child {
  margin-left: 0 !important;
}
.filter-form-container .form-container .form-content .ant-select-single:not(.ant-select-customize-input) .ant-select-selector, .filter-form-container .form-container .form-content .ant-select-multiple .ant-select-selector {
  height: 38px;
  padding: 4px 8px;
}
.filter-form-container .form-container .form-footer {
  margin-top: 0;
  margin-left: 0;
  display: flex;
  justify-content: flex-start;
}
.filter-form-container .form-container .form-footer button {
  margin-left: 0 !important;
  margin-bottom: 16px;
  margin-right: 24px;
}
.filter-form-container .form-container .form-footer button:last-child {
  margin-right: 0;
}
@media (max-width: 530px) {
  .filter-form-container .form-container {
    width: 100%;
  }
  .filter-form-container .form-container .form-content {
    width: 100%;
  }
  .filter-form-container .form-container .form-content .ant-form-item {
    width: 100%;
    min-width: 100%;
    margin-right: 0 !important;
  }
  .filter-form-container .form-container .form-footer {
    width: 100%;
  }
}

.btn-table-action-primary {
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  color: #1E88E5;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}
.btn-table-action-primary > div {
  margin-left: 8px;
}

.btn-table-action-danger {
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  color: #F44336;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}
.btn-table-action-danger > div {
  margin-left: 8px;
}`, "",{"version":3,"sources":["webpack://./src/global.scss","webpack://./src/mixins.scss"],"names":[],"mappings":"AAGA;EACE,8CAAA;AADF;;AAIA;EACE,SAAA;EACA,UAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AADF;;AAIA;EACE,qBAAA;AADF;;AAIA;EACE,YAAA;EACA,aAAA;EC0FA,iBAAA;EACA,gBAAA;EACA,aAAA;EA0BA,2BDnHyB;ECoHzB,0BDpHyB;ECqHzB,uBDrHyB;ECqGzB,uBDpGqB;ECqGrB,sBDrGqB;ECsGrB,mBDtGqB;AAOvB;;AAJA;EACE,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;ECtBA,kBDuBuB;AAUzB;AARE;EACE,eAAA;EACA,iBAAA;AAUJ;;AANA;EACE,2BAAA;AASF;;AANA;EACE,0BAAA;AASF;;AANA;EACE,UAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;AASF;AALI;EACE,YAAA;EACA,YAAA;AAON;AAJI;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;AAMN;AAFE;ECiCA,iBAAA;EACA,gBAAA;EACA,aAAA;AD3BF;AANI;EACE,WAAA;EACA,iBAAA;EC6BJ,iBAAA;EACA,gBAAA;EACA,aAAA;ADnBF;AATM;EACE,WAAA;EACA,kBAAA;AAWR;AARI;EACE,cAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAUN;AARM;EACE,gBAAA;AAUR;AANQ;EACE,WAAA;AAQV;AAHI;EACE,iBAAA;AAKN;AAJM;EACE,WAAA;AAMR;AALQ;EACE,YAAA;AAOV;;AACE;EACE,WAAA;EACA,gBAAA;AAEJ;;AAGE;EACE,YAAA;AAAJ;AACI;EACE,gBAAA;EACA,iBAAA;AACN;;AAIA;EACE,sBAAA;EC3BA,iBAAA;EACA,gBAAA;EACA,aAAA;EA0BA,kCDCyB;ECAzB,iCAAA;EACA,8BDDyB;EACzB,UAAA;AAKF;;AADE;EACE,mBAAA;AAIJ;AAHI;EACE,gBAAA;EACA,gBAAA;AAKN;AAAI;EACE,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAEN;AAAM;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AAER;AAGE;EACE,gBAAA;AADJ;AAIM;ECnEJ,iBAAA;EACA,gBAAA;EACA,aAAA;ADmEF;AAMM;EACE,WAAA;EACA,aAAA;AAJR;AAQI;EACE,mBAAA;AANN;AAOM;EACE,iBAAA;AALR;AASI;EACE,mBAAA;ECzFJ,iBAAA;EACA,gBAAA;EACA,aAAA;EA0BA,2BD+D6B;EC9D7B,0BD8D6B;EC7D7B,uBD6D6B;EC7E7B,uBD8EyB;EC7EzB,sBD6EyB;EC5EzB,mBD4EyB;AAE3B;AAAM;EACE,qBCxMO;EDyMP,cCzMO;AD2Mf;AAGE;EACE,gBAAA;ECtGF,iBAAA;EACA,gBAAA;EACA,aAAA;EA0BA,6BD4E2B;EC3E3B,4BD2E2B;EC1E3B,yBD0E2B;AAK7B;AAHI;EACE,iBAAA;AAKN;AAJM;EACE,cAAA;AAMR;AADM;EACE,eAAA;AAGR;AAEE;EACE,yBAAA;EACA,0BAAA;AAAJ;AAGE;EACE,0BAAA;EACA,2BAAA;AADJ;AAIE;EClIA,iBAAA;EACA,gBAAA;EACA,aAAA;EA0BA,kCDwG2B;ECvG3B,iCDuG2B;ECtG3B,8BDsG2B;AAI7B;AAFI;EACE,UAAA;AAIN;AAFM;EACE,iBAAA;AAIR;AAAI;EACE,WAAA;AAEN;AAEE;EACE;IACE,iBAAA;EAAJ;AACF;;AAIA;EACE,YAAA;EACA,wBAAA;AADF;AAGE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EAEA,OAAA;AAFJ;;AAQI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;AALN;;AAUA;EACE,aAAA;AAPF;AASE;EAEE,gBAAA;EACA,mBAAA;EACA,eAAA;EC1LF,iBAAA;EACA,gBAAA;EACA,aAAA;EA0BA,kCDgK2B;EC/J3B,iCD+J2B;EC9J3B,8BD8J2B;EC9K3B,uBD+KuB;EC9KvB,sBD8KuB;EC7KvB,mBD6KuB;AACzB;AAEM;EACE,yBAAA;AAAR;AAKE;ECtMA,iBAAA;EACA,gBAAA;EACA,aAAA;ADqMF;AAEI;EACE,kBAAA;AAAN;AAIE;EACE,aAAA;EAEA,iBAAA;ECvSF,+CDwSsB;ECvStB,2CDuSsB;ECrTtB,kBDsTyB;AAG3B;AAAI;EACE,WAAA;AAEN;AACI;EACE,mBAAA;EC3NJ,iBAAA;EACA,gBAAA;EACA,aAAA;EA0BA,kCDiM6B;EChM7B,iCDgM6B;EC/L7B,8BD+L6B;EC/M7B,uBDgNyB;EC/MzB,sBD+MyB;EC9MzB,mBD8MyB;AAU3B;AARM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBCrVQ;AD+VhB;AARQ;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,oCC3VM;ED4VN,kBAAA;EACA,MAAA;EACA,WAAA;AAUV;AANM;EClPJ,iBAAA;EACA,gBAAA;EACA,aAAA;AD4PF;AATQ;EACE,kBAAA;AAWV;AATU;EACE,cAAA;AAWZ;AAJM;EACE,kBAAA;EACA,qBAAA;EACA,gCAAA;ECnQN,iBAAA;EACA,gBAAA;EACA,aAAA;EAYA,uBDuP2B;ECtP3B,sBDsP2B;ECrP3B,mBDqP2B;AAY7B;AAVQ;EACE,mBAAA;AAYV;AATQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AAWV;AARQ;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAUV;AARU;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;ECvYV,kBDyYiC;AAYnC;AAVY;EACE,cAAA;EACA,yCAAA;AAYd;AATY;EACE,cAAA;EACA,wCAAA;AAWd;AARY;EACE,cAAA;EACA,yBAAA;AAUd;AAPY;EACE,cAAA;EACA,2CAAA;AASd;AANY;EACE,cAAA;EACA,0CAAA;AAQd;AALY;EACE,cAAA;EACA,yCAAA;AAOd;AACE;EACE,gBAAA;EC5UF,iBAAA;EACA,gBAAA;EACA,aAAA;EAYA,uBDgUuB;EC/TvB,sBD+TuB;EC9TvB,mBD8TuB;EClTvB,6BDmT2B;EClT3B,4BDkT2B;ECjT3B,yBDiT2B;AAU7B;AARI;EACE,kBAAA;AAUN;AARM;EACE,eAAA;AAUR;AALE;EACE;IACE,WAAA;EAOJ;AACF;AAJE;EACE;ICnVF,2BDoVyB;ICnVzB,0BDmVyB;IClVzB,uBDkVyB;IACrB,sBAAA;EASJ;EAPI;IACE,8BAAA;EASN;AACF;;AAHE;EACE,aAAA;AAMJ;AAJM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBCreQ;AD2ehB;AAJQ;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,oCC3eM;ED4eN,kBAAA;EACA,MAAA;EACA,WAAA;AAMV;AAAM;EACE,iBAAA;AAER;AAEI;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBC9fU;ED+fV,mBAAA;AAAN;AACM;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,oCCpgBQ;EDqgBR,kBAAA;EACA,MAAA;EACA,WAAA;AACR;;AAME;EACE,YAAA;AAHJ;AAII;EACE,YAAA;AAFN;AAKI;ECpaF,iBAAA;EACA,gBAAA;EACA,aAAA;ADmaF;AAEM;EACE,aAAA;AAAR;AAII;EACE,cCthBS;ADohBf;AAKI;EACE,WAAA;ECjbJ,iBAAA;EACA,gBAAA;EACA,aAAA;EA0BA,2BDuZ6B;ECtZ7B,0BDsZ6B;ECrZ7B,uBDqZ6B;AAG/B;AADM;EACE,gBAAA;AAGR;AADQ;EACE,sBAAA;EACA,yBC1iBM;ED2iBN,oCAAA;AAGV;AAAQ;EACE,iBAAA;EACA,oCChjBM;EDijBN,WAAA;EACA,oCAAA;AAEV;;AAME;EACE,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,2BAAA;AAHJ;AAKI;EACE,+BAAA;AAHN;AAMI;EACE,8BAAA;AAJN;AAOI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,UAAA;AALN;AAQI;EACE,kBAAA;ECteJ,iBAAA;EACA,gBAAA;EACA,aAAA;EAYA,uBD0dyB;ECzdzB,sBDydyB;ECxdzB,mBDwdyB;AAA3B;AAGI;EACE,eAAA;EACA,gBAAA;AADN;AAGM;EACE,gBAAA;AADR;AAKI;EACE,kBAAA;ECxlBJ,kBDylB2B;AAA7B;AAEM;EACE,eAAA;EACA,yBC1mBQ;ED4mBR,eAAA;AAAR;AAKE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAHJ;AAOI;EACE,kBAAA;AALN;AAOM;EACE,+BAAA;AALR;AAQM;EACE,8BAAA;AANR;AASM;ECrhBJ,iBAAA;EACA,gBAAA;EACA,aAAA;EA0BA,2BD2f+B;EC1f/B,0BD0f+B;ECzf/B,uBDyf+B;ECzgB/B,uBD0gB2B;ECzgB3B,sBDygB2B;ECxgB3B,mBDwgB2B;AAE7B;AAAQ;EACE,iBAAA;EACA,kBAAA;AAEV;AAAU;EACE,cAAA;AAEZ;AAGU;EACE,oBAAA;EACA,YAAA;EACA,6BAAA;ECplBV,wBDqlB6B;AAG/B;AADY;EACE,aAAA;AAGd;AAAY;EACE,YAAA;AAEd;AAIM;EACE,0BAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EClqBN,kBDmqB6B;AAC/B;AAEM;EACE,cAAA;EACA,wCAAA;AAAR;AAGM;EACE,cAAA;EACA,2CAAA;AADR;AAIM;EC7kBJ,iBAAA;EACA,gBAAA;EACA,aAAA;EAYA,uBDikB2B;EChkB3B,sBDgkB2B;EC/jB3B,mBD+jB2B;AAI7B;AAFQ;EACE,kBAAA;AAIV;AAFU;ECplBR,iBAAA;EACA,gBAAA;EACA,aAAA;AD0lBF;AADQ;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;AAGV;AAAQ;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAEV;AAIM;EACE,oBAAA;AAFR;AAMI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;ECvlBJ,2BDwlB6B;ECvlB7B,0BDulB6B;ECtlB7B,uBDslB6B;ECtmB7B,uBDumByB;ECtmBzB,sBDsmByB;ECrmBzB,mBDqmByB;AAE3B;AAAM;EACE,gBAAA;AAER;AACM;EACE,WAAA;EACA,YAAA;AACR;;AAME;ECvuBA,kBDwuByB;AAA3B;AAEI;EACE,YAAA;EACA,6BAAA;EACA,yBAAA;AAAN;;AAKA;EACE,sBAAA;EACA,0BAAA;EACA,yBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,SAAA;EACA,0BAAA;EACA,gBAAA;EACA,6CAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,0BAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;AAHF;;AAcA;EACE,cAAA;AAHF;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;AAKE;EACE,qBAAA;EACA,4CAAA;EACA,4BAAA;EACA,UAAA;AAHJ;;AAQE;EACE,gBAAA;AALJ;AAQE;ECzsBA,iBAAA;EACA,gBAAA;EACA,aAAA;EAYA,uBD6rBuB;EC5rBvB,sBD4rBuB;EC3rBvB,mBD2rBuB;EACrB,eAAA;AAAJ;AAEI;EACE,aAAA;EACA,eAAA;EChtBJ,iBAAA;EACA,gBAAA;EACA,aAAA;ADktBF;AAAM;EACE,WAAA;EACA,gBAAA;AAER;AACM;EACE,gBAAA;EACA,6BAAA;AACR;AACQ;EACE,yBAAA;AACV;AAGM;EACE,YAAA;EACA,gBAAA;AADR;AAKI;EACE,aAAA;EACA,cAAA;EACA,aAAA;EACA,2BAAA;AAHN;AAIM;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;AAFR;AAIQ;EACE,eAAA;AAFV;AAQE;EACE;IACE,WAAA;EANJ;EAOI;IACE,WAAA;EALN;EAMM;IACE,WAAA;IACA,eAAA;IACA,0BAAA;EAJR;EAQI;IACE,WAAA;EANN;AACF;;AAWA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;ECjxBA,iBAAA;EACA,gBAAA;EACA,aAAA;AD2wBF;AAQE;EACE,gBAAA;AANJ;;AAUA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EC/xBA,iBAAA;EACA,gBAAA;EACA,aAAA;AD0xBF;AAOE;EACE,gBAAA;AALJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n@import './mixins.scss';\n\n* {\n  -webkit-backface-visibility:hidden !important;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  background: #F1F3F6;\n  font-size: 14px;\n  height: 24px;\n  font-weight: 400;\n}\n\na {\n  text-decoration: none;\n}\n\n.loading-screen {\n  width: 100vw;\n  height: 100vh;\n\n  @include flex;\n  @include justify-content(center);\n  @include align-items(center);\n}\n \n.ant-btn {\n  padding: 6px 12px 6px 12px;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 14px;\n  height: auto !important;\n  @include border-radius(2px);\n\n  span + .anticon {\n    margin-right: 0;\n    margin-left: 10px;\n  }\n}\n\n.ant-notification-notice-message {\n  margin-bottom: 0 !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize;\n}\n\n.ant-layout-header  {\n  padding: 0;\n  background-color: #23395d;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  z-index: 999;\n\n  .logo {\n    // padding: 0 10px;\n    img {\n      width: 200px;\n      height: 60px;\n    }\n\n    span {\n      margin-left: 10px;\n      font-size: 12px;\n      line-height: 16px;\n      font-weight: 600;\n      padding: 4px 7px;\n      background-color: #fff;\n      color: #1E88E5;\n      border-radius: 11px;\n    }\n  }\n\n  .account-info {\n    @include flex;\n    .avatar {\n      width: 32px;\n      margin-left: 10px;\n      @include flex;\n\n      img {\n        width: 100%;\n        border-radius: 50%;\n      }\n    }\n    .info { \n      margin: auto 0;\n      padding: 10px;\n      line-height: 16px;\n      font-size: 12px;\n      color: #212121;\n\n      .fullname {\n        font-weight: 600;\n      }\n\n      .info-dropdown {\n        button {\n          width: 100%;\n        }\n      }\n    }\n\n    .ant-badge {\n      margin: auto 10px;\n      .anticon {\n        width: 40px;\n        svg {\n          height: 24px;\n        }\n      }\n    }\n  }\n}\n\n.header-info-dropdown {\n  button {\n    width: 100%;\n    text-align: left;\n  }\n}\n\n.site-layout {\n  .Content {\n    margin: 20px;\n    &.Small {\n      max-width: 760px;\n      margin: 20px auto;\n    }\n  }\n}\n\n.ant-layout-header.site-header {\n  background-color: #fff;\n  @include flex;\n  @include justify-content(space-between);\n  z-index: 1\n}\n\n.form-container {\n  .ant-form-item {\n    margin-bottom: 16px;\n    .ant-form-item-label {\n      min-width: 156px;\n      text-align: left;\n    }\n  }\n\n  .form-header {\n    .title {\n      text-transform: uppercase;\n      font-size: 12px;\n      line-height: 16px;\n      font-weight: 600;\n      position: relative;\n      color: #005670;\n\n      &:before {\n        content: '';\n        width: 4px;\n        height: 100%;\n        background-color: #005670;\n        position: absolute;\n        top: 0;\n        left: -16px;\n      }\n    }\n  }\n\n  .form-content {\n    margin-top: 24px;\n\n    .ant-form-item-row {\n      .ant-form-item-control .ant-form-item-control-input .ant-form-item-control-input-content {\n        @include flex;\n      }\n    }\n\n    \n\n    .add-fields {\n      .ant-btn-dashed.ant-btn-block {\n        width: auto;\n        margin-top: 0;\n      }\n    }\n  \n    .btn-remove-section {\n      margin-bottom: 16px;\n      .ant-btn {\n        padding: 4px 40px;\n      }\n    }\n  \n    .ant-btn-dashed.ant-btn-block {\n      margin-bottom: 16px;\n      @include flex;\n      @include justify-content(center);\n      @include align-items(center);\n  \n      &.btn-remove {\n        border-color: $danger-color;\n        color: $danger-color;\n      }\n    }\n  }\n\n  .form-footer {\n    margin-top: 24px;\n    @include flex;\n    @include justify-content(flex-end);\n\n    button, a {\n      margin-left: 24px;\n      &:first-child {\n        margin-left: 0;\n      }\n    }\n\n    a > button {\n      &:first-child {\n        margin-right: 0;\n      }\n    }\n  }\n\n  .ant-row {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n  \n  .ant-row .ant-col {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .fields-inline {\n    @include flex;\n    @include justify-content(space-between);\n\n    .ant-form-item {\n      width: 50%;\n\n      &:last-child {\n        margin-left: 24px;\n      }\n    }\n\n    .ant-picker {\n      width: 100%;\n    }\n  }\n\n  @media (max-width: 767px) {\n    .ant-row {\n      flex-flow: column;\n    }\n  }\n}\n\n.ant-form-item-explain {\n  height: auto;\n  min-height: 0 !important;\n\n  .ant-form-item-explain-error {\n    font-size: 10px;\n    min-height: 12px;\n    position: absolute;\n    // bottom: -15px;\n    left: 0;\n  }\n}\n\n.ant-form-item-with-help.password-input {\n  .ant-form-item-explain {\n    div, .ant-form-item-explain-error, .ant-form-item-explain-success {\n      font-size: 10px;\n      min-height: 12px;\n      position: absolute;\n      top: 32px;\n      left: 0;\n    }\n  }\n}\n\n.page-container {\n  padding: 24px;\n  // background-color:#23395d;\n  .page-header {\n\n    margin-top: 16px;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n    @include flex;\n    @include justify-content(space-between);\n    @include align-items(center);\n\n    .ant-breadcrumb {\n      span {\n        text-transform: uppercase;\n      }\n    }\n  }\n  \n  .page-header-actions {\n    @include flex;\n\n    button:not(:last-child), a:not(:last-child) {\n      margin-right: 12px;\n    }\n  }\n\n  .page-content {\n    padding: 16px;\n    // background: #23395d;\n    margin: 24px auto;\n    @include box-shadow(0px 0px 4px rgba(0, 0, 0, 0.08));\n    @include border-radius(2px);\n\n\n    &.list {\n      width: 100%;\n    }\n\n    .page-content-header {\n      margin-bottom: 24px;\n      @include flex;\n      @include justify-content(space-between);\n      @include align-items(center);\n\n      h2.title-page {\n        font-size: 12px;\n        line-height: 16px;\n        font-weight: 600;\n        position: relative;\n        color: $primary-color;\n\n        &:before {\n          content: '';\n          width: 4px;\n          height: 100%;\n          background-color: $primary-color;\n          position: absolute;\n          top: 0;\n          left: -16px;\n        }\n      }\n\n      .page-content-header-actions {\n        @include flex;\n        \n        button {\n          margin-right: 16px;\n\n          &:first-child {\n            margin-left: 0;\n          }\n        }\n      }\n    }\n\n    .details-container {\n      .item {\n        padding-top: 7.5px;\n        padding-bottom: 7.5px;\n        border-bottom: 1px solid #e0e0e0;\n        @include flex;\n        @include align-items(center);\n\n        &:last-child {\n          border-bottom: none;\n        }\n  \n        label {\n          min-width: 152px;\n          font-size: 12px;\n          line-height: 16px;\n          font-weight: 600;\n          white-space: pre-line;\n          max-width: 152px;\n          margin-right: 24px;\n        }\n  \n        span.value {\n          font-size: 14px;\n          line-height: 16px;\n          font-weight: 400;\n\n          &.status {\n            display: block;\n            width: 120px;\n            padding-top: 4px;\n            padding-bottom: 4px;\n            font-weight: 600;\n            font-size: 12px;\n            font-style: normal;\n            line-height: 16px;\n            text-align: center;\n            text-transform: capitalize;\n\n            @include border-radius(2px);\n\n            &.rejected, &.cancelled, &.disabled {\n              color: #f44336;\n              background-color: rgba(244, 67, 54, 0.12);\n            }\n\n            &.approved, &.completed, &.enabled, &.open, &.active {\n              color: #00c853;\n              background-color: rgba(0, 200, 83, 0.12);\n            }\n\n            &.pending, &.refunded, &.closed {\n              color: #ad6800;\n              background-color: #ffe58f;\n            }\n\n            &.created, &.inactive {\n              color: #888888;\n              background-color: rgba(136, 136, 136, 0.12);\n            }\n            \n            &.acknowledged, &.upcoming {\n              color: #1E88E5;\n              background-color: rgba(30,136,229,0.12);\n            }\n\n            &.attending {\n              color: #FFC400;\n              background-color: rgba(255,196,0,0.12);\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .page-content-footer {\n    margin-top: 24px;\n    @include flex;\n    @include align-items(center);\n    @include justify-content(flex-end);\n\n    button, a {\n      margin-right: 12px;\n\n      &:last-child{\n        margin-right: 0;\n      }\n    }\n  }\n\n  @media (max-width: 1199px) {\n    .page-content {\n      width: 100%;\n    }\n  }\n\n  @media (max-width: 479px) {\n    .page-content .details-container .item {\n      @include align-items(flex-start);\n      flex-direction: column;\n\n      label {\n        margin-bottom: 16px !important;\n      }\n    }\n  }\n}\n\n.ant-modal-content {\n  .ant-modal-body {\n    padding: 10px;\n    .form-header {\n      .title {\n        font-size: 12px;\n        line-height: 16px;\n        font-weight: 600;\n        position: relative;\n        color: $primary-color;\n\n        &:before {\n          content: '';\n          width: 4px;\n          height: 100%;\n          background-color: $primary-color;\n          position: absolute;\n          top: 0;\n          left: -16px;\n        }\n      }\n    }\n\n    .form-content {\n      .ant-form-item {\n        flex-flow: column;\n      }\n    }\n\n    h2.title-page {\n      font-size: 12px;\n      line-height: 16px;\n      font-weight: 600;\n      position: relative;\n      color: $primary-color;\n      margin-bottom: 24px;\n      &:before {\n        content: '';\n        width: 4px;\n        height: 100%;\n        background-color: $primary-color;\n        position: absolute;\n        top: 0;\n        left: -16px;\n      }\n    }\n  }\n}\n\n.ant-modal-confirm-confirm {\n  .ant-modal-content {\n    width: 331px;\n    .ant-modal-body {\n      padding: 0px;\n    }\n\n    .ant-modal-confirm-body {\n      @include flex;\n\n      .ant-modal-confirm-content {\n        margin-top: 0;\n      }\n    }\n\n    .ant-modal-confirm-body span.anticon.anticon-exclamation-circle {\n      color: $danger-color;\n    }\n\n    .ant-modal-confirm-btns {\n      width: 100%;\n      @include flex;\n      @include justify-content(center);\n\n      button {\n        min-width: 100px;\n\n        &:first-child {\n          background-color: #fff;\n          color: $primary-color;\n          border: 1px solid $primary-color;\n        }\n\n        &.ant-btn-primary {\n          margin-left: 16px;\n          background-color: $primary-color;\n          color: #fff;\n          border: 1px solid $primary-color;\n        }\n      }\n    }\n  }\n}\n\ntable {\n  thead.ant-table-thead th {\n    padding: 10px 16px;\n    border-top: 1px solid $border-color;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 16px;\n    flex: none;\n    background: #fff !important;\n\n    &:first-child {\n      border-right: 1px solid $border-color;\n    }\n\n    &:last-child {\n      border-left: 1px solid $border-color;\n    }\n\n    span.ant-table-filter-column-title {\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 16px;\n      flex: none;\n      padding: 0;\n    }\n\n    .ant-table-filter-column {\n      padding: 17px 16px;\n      @include flex;\n      @include align-items(center);\n    }\n\n    .ant-table-filter-trigger-container {\n      position: unset;\n      margin-left: 5px;\n\n      &:hover {\n        background: #fff;\n      }\n    }\n\n    .ant-table-filter-trigger {\n      text-align: center;\n      @include border-radius(2px);\n\n      .anticon {\n        position: unset;\n        color: $primary-color;\n        -webkit-transform: none;\n        transform: none;\n      }\n    }\n  }\n  \n  td {\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n    background: #fff;\n  }\n\n  tbody.ant-table-tbody {\n    tr td {\n      padding: 12px 16px;\n\n      &:first-child {\n        border-right: 1px solid #F4F4F4;\n      }\n\n      &:last-child {\n        border-left: 1px solid $border-color;\n      }\n\n      span.action {\n        @include flex;\n        @include justify-content(center);\n        @include align-items(center);\n\n        & > button, & > a {\n          padding-left: 8px;\n          padding-right: 8px;\n\n          & > button {\n            padding: 6px 0;\n          }\n        }\n\n        .ant-dropdown-button {\n          button {\n            padding: 0 6px 0 6px;\n            border: none;\n            background-color: transparent;\n            @include transform(rotate(90deg));\n\n            &:first-child {\n              display: none;\n            }\n\n            span.anticon.anticon-ellipsis {\n              height: 16px;\n            }\n          }\n        }\n      }\n\n      span.table-status {\n        text-transform: capitalize;\n        padding-top: 4px;\n        padding-bottom: 4px;\n        width: 120px;\n        display: block;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 16px;\n        text-align: center;\n        @include border-radius(2px);\n      }\n    \n      span.table-status.active {\n        color: #00C853;\n        background-color: rgba(0,200,83,0.12);\n      }\n\n      span.table-status.inactive {\n        color: #888888;\n        background-color: rgba(136, 136, 136, 0.12);\n      }\n\n      .foreign-currency-td {\n        @include flex;\n        @include align-items(center);\n\n        & > div {\n          margin-right: 12px;\n\n          & > div {\n            @include flex;\n          }\n        }\n      }\n\n      .sms-transaction-details {\n        .details-type {\n          font-size: 12px;\n          line-height: 16px;\n          font-weight: 600;\n          text-transform: capitalize;\n        }\n\n        .details-account-no {\n          font-size: 12px;\n          line-height: 16px;\n          font-weight: 400;\n        }\n      }\n    }\n\n    tr:last-child {\n      td {\n        padding-bottom: 12px;\n      }\n    }\n\n    .btn-download {\n      position: relative;\n      min-width: 100%;\n      min-height: 32px;\n      @include justify-content(center);\n      @include align-items(center);\n\n      &> div {\n        margin-left: 0px;\n      }\n\n      svg {\n        width: 16px;\n        height: 30px;\n      }\n    }\n  }\n}\n\n.table-action-menu {\n  .ant-dropdown-menu {\n    @include border-radius(4px);\n    \n    .btn-danger {\n      border: none;\n      background-color: transparent;\n      color: #F4F4F4 !important;\n    }\n  }\n}\n\n.ant-input, .ant-select-selector, .ant-picker {\n  background-color: #fff;\n  font-size: 14px !important;\n  border: 1px solid #E0E0E0;\n  border-radius: 2px !important;\n  min-height: 32px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n  // box-sizing: border-box;\n  margin: 0;\n  font-variant: tabular-nums;\n  list-style: none;\n  font-feature-settings: \"tnum\",\"tnum\";\n  position: relative;\n  min-width: 0;\n  padding: 4px 11px;\n  color: rgba(0,0,0,.85);\n  line-height: 1.5715;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 2px;\n  transition: all .3s;\n}\n\ninput.ant-input::-webkit-input-placeholder {\n  color: #d9d9d9;\n}\n\ninput.ant-input:-ms-input-placeholder {\n  color: #d9d9d9;\n}\n\ninput.ant-input::placeholder {\n  color: #d9d9d9;\n}\n\n.ant-input:not[textarea], .ant-select-selector, .ant-picker {\n  height: 32px !important;\n}\n\n.ant-input {\n  min-height: 30px;\n\n  &:focus {\n    border-color: #4096ff;\n    box-shadow: 0 0 0 2px rgb(5 145 255 / 10%);\n    border-inline-end-width: 1px;\n    outline: 0;\n  }\n}\n\n.filter-form-container {\n  .ant-input {\n    min-height: 38px;\n  }\n  \n  .form-container {\n    @include flex;\n    @include align-items(center);\n    flex-wrap: wrap;\n\n    .form-content {\n      margin-top: 0;\n      flex-wrap: wrap;\n      \n      @include flex;\n\n      .ant-picker {\n        width: auto;\n        min-height: 38px;\n      }\n\n      .ant-form-item, .ant-select {\n        min-width: 200px;\n        margin-right: 16px !important;\n\n        &:first-child { \n          margin-left: 0 !important;\n        }\n      }\n\n      .ant-select-single:not(.ant-select-customize-input) .ant-select-selector, .ant-select-multiple .ant-select-selector {\n        height: 38px;\n        padding: 4px 8px;\n      }\n    }\n\n    .form-footer {\n      margin-top: 0;\n      margin-left: 0; \n      display: flex;\n      justify-content: flex-start;\n      button {\n        margin-left: 0 !important; \n        margin-bottom: 16px;\n        margin-right: 24px;\n\n        &:last-child  {\n          margin-right: 0;\n        }\n      }\n    }\n  }\n\n  @media (max-width: 530px) {\n    .form-container {\n      width: 100%;\n      .form-content {\n        width: 100%;\n        .ant-form-item {\n          width: 100%;\n          min-width: 100%;\n          margin-right: 0 !important;\n        }\n      }\n\n      .form-footer {\n        width: 100%;\n      }\n    }\n  }\n}\n\n.btn-table-action-primary {\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n  color: #1E88E5;\n\n  @include flex;\n\n  & > div {\n    margin-left: 8px;\n  }\n}\n\n.btn-table-action-danger {\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n  color: #F44336;\n\n  @include flex;\n\n  & > div {\n    margin-left: 8px;\n  }\n}","$primary-color: #23395d !important;\n$primary-text: #212121;\n$secondary-color: #E87722;\n$border-color: #F4F4F4;\n$yellow-color: #FFC400;\n$blue-color: #005670;\n$green-color: #00C853;\n$danger-color: #F44336;\n\n@mixin border-radius($value) {\n  -webkit-border-radius: $value;\n  -moz-border-radius: $value;\n  -ms-border-radius: $value;\n  border-radius: $value;\n}\n\n@mixin text-shadow($value) {\n  -webkit-text-shadow: $value;\n  -moz-text-shadow: $value;\n  -ms-text-shadow: $value;\n  text-shadow: $value;\n}\n\n@mixin box-shadow($value) {\n  -webkit-box-shadow: $value;\n  -moz-box-shadow: $value;\n  -ms-box-shadow: $value;\n  box-shadow: $value;\n}\n\n@mixin transition-all($time) {\n  -webkit-transition: all $time;\n  -o-transition: all $time;\n  -ms-transition: all $time;\n  transition: all $time;\n}\n\n@mixin transition-all-effect($time, $effect) {\n  -webkit-transition: all $time $effect;\n  -o-transition: all $time $effect;\n  -ms-transition: all $time $effect;\n  transition: all $time $effect;\n}\n\n@mixin filter-blur($value) {\n  -webkit-filter: blur($value);\n  -moz-filter: blur($value);\n  -o-filter: blur($value);\n  -ms-filter: blur($value);\n  filter: blur($value);\n  filter: url(#blur);\n  filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius='3.5');\n}\n\n@mixin user-select {\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n}\n\n@mixin transform($value) {\n  -webkit-transform: $value;\n  -moz-transform: $value;\n  -ms-transform: $value;\n  -o-transform: $value;\n  transform: $value;  \n}\n\n@mixin transform-style($value) {\n  -webkit-transform-style: $value;\n  -moz-transform-style: $value;\n  transform-style: $value;\n}\n\n@mixin transform-rotateX($value) {\n  -webkit-transform: rotateX($value);\n  -moz-transform: rotateX($value);\n  -o-transform: rotateX($value);\n  transform: rotateX($value);\n}\n\n@mixin transform-rotateY($value) {\n  -webkit-transform: rotateY($value);\n  -moz-transform: rotateY($value);\n  -o-transform: rotateY($value);\n  transform: rotateY($value);\n}\n\n@mixin transform-rotateZ($value) {\n  -webkit-transform: rotateZ($value);\n  -moz-transform: rotateZ($value);\n  -o-transform: rotateZ($value);\n  transform: rotateZ($value);\n}\n\n@mixin transition-duration($value) {\n  -webkit-transition-duration: $value;\n  -ms-transition-duration: $value;\n  -o-transition-duration: $value;\n  transition-duration: $value;\n}\n\n@mixin visibility($value) {\n  -webkit-backface-visibility: $value;\n  -moz-backface-visibility: $value;\n  backface-visibility: $value;\n}\n\n@mixin flex {\n  display: -webkit-flex;\n  display: -ms-flex;\n  display: -o-flex;\n  display: flex;\n}\n\n@mixin table {\n  display: -webkit-table;\n  display: -ms-table;\n  display: -o-table;\n  display: table;\n}\n\n@mixin align-items($position) {\n  -webkit-align-items: $position;\n  -ms-align-items: $position;\n  -o-align-items: $position;\n  align-items: $position;\n}\n\n@mixin align-self($position) {\n  -webkit-align-self: $position;\n  -ms-align-self: $position;\n  -o-align-self: $position;\n  align-self: $position;\n}\n\n@mixin justify-content($position) {\n  -webkit-justify-content: $position;\n  -ms-justify-content: $position;\n  -o-justify-content: $position;\n  justify-content: $position;\n}\n\n@mixin flex-direction($position) {\n  -webkit-flex-direction: $position;\n  -ms-flex-direction: $position;\n  -o-flex-direction: $position;\n  flex-direction: $position;\n}\n\n@mixin flex-wrap($value) {\n  -webkit-flex-wrap: $value;\n  -ms-flex-wrap: $value;\n  -o-flex-wrap: $value;\n  flex-wrap: $value;\n}\n\n@mixin placeholder {\n  ::-webkit-input-placeholder {@content}\n  :-moz-placeholder           {@content}\n  ::-moz-placeholder          {@content}\n  :-ms-input-placeholder      {@content}  \n}\n\n@mixin hyphens($value) {\n  -webkit-hyphens: $value;\n  -ms-hyphens: $value;\n  -o-hyphens: $value;\n  hyphens: $value;\n}\n\n@mixin transition($value) {\n  -webkit-transition: $value;\n  -o-transition: $value;\n  -ms-transition: $value;\n  transition: $value;\n}\n\n@mixin border-top-right-radius($value) {\n  -webkit-borde-top-right-radius: $value;\n  -moz-border-top-right-radius: $value;\n  -ms-border-top-right-radius: $value;\n  border-top-right-radius: $value;\n}\n\n@mixin border-bottom-right-radius($value) {\n  -webkit-borde-bottom-right-radius: $value;\n  -moz-border-bottom-right-radius: $value;\n  -ms-border-bottom-right-radius: $value;\n  border-bottom-right-radius: $value;\n}\n\n@mixin border-top-left-radius($value) {\n  -webkit-borde-top-left-radius: $value;\n  -moz-border-top-left-radius: $value;\n  -ms-border-top-left-radius: $value;\n  border-top-left-radius: $value;\n}\n\n@mixin border-bottom-left-radius($value) {\n  -webkit-borde-bottom-left-radius: $value;\n  -moz-border-bottom-left-radius: $value;\n  -ms-border-bottom-left-radius: $value;\n  border-bottom-left-radius: $value;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
